import { Reveal } from "./Reveal";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 px-6 pb-10 pt-24 md:px-10">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <p data-testid="footer-wordmark" className="text-center font-serif font-light leading-none text-neutral-100">
            <span className="block text-[14vw] tracking-[0.12em] md:text-[9vw]">TABI</span>
            <span className="block text-[4.5vw] italic tracking-[0.22em] text-gold-light md:text-[2.5vw]">ESSENCE OF STRENGTH</span>
          </p>
        </Reveal>

        <div className="gold-rule mx-auto mt-16 w-full max-w-md opacity-60" />

        <div className="mt-10 flex flex-col items-center justify-between gap-6 md:flex-row">
          <p data-testid="footer-tagline" className="font-serif text-sm italic text-neutral-500">
            Honouring the past, inspiring the future.
          </p>
          <div className="flex items-center gap-8">
            <a
              href="https://instagram.com/tabi.essenceuk"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="text-xs uppercase tracking-[0.25em] text-neutral-400 transition-colors duration-300 hover:text-gold-light"
            >
              Instagram
            </a>
            <a
              href="mailto:tabiessenceofstrength@gmail.com"
              data-testid="footer-email-link"
              className="text-xs uppercase tracking-[0.25em] text-neutral-400 transition-colors duration-300 hover:text-gold-light"
            >
              Email
            </a>
            <span data-testid="footer-domain" className="text-xs uppercase tracking-[0.25em] text-neutral-500">
              tabiessence.co.uk
            </span>
          </div>
          <p data-testid="footer-copyright" className="text-xs font-light text-neutral-600">
            © 2026 TABI Essence of Strength. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
